import classNames from 'classnames';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import Button from '../../GbsUI/UI/Button';
import ArrowLeftIcon from '../../GbsUI/UI/icons/ArrowLeft';
import ArrowRightIcon from '../../GbsUI/UI/icons/ArrowRight';
import Section from '../../GbsUI/UI/Section';
import HelloPage from './pages/Hello';
import InterestsPage from './pages/Interests';
import QuestionsPage from './pages/Questions';
import SchoolPage from './pages/School';
import SignUpPage from './pages/SignUp';
import './styles.css';
import SuccessPage from './pages/Success';

const defaultStateData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  city: '',
  graduationYear: null,
  graduationYearCustom: '',
  school: null,
  schoolCustom: '',
  firm: null,
  firmCustom: '',
  firmStartYear: null,
  firmStartYearCustom: '',
  careerInterests: [],
  careerInterestsCustom: '',
  recruitingResources: [
    'interview_prep_resources',
    'recruiting_updates',
    'compensation_report_info',
  ],
  recruitingResourcesCustom: '',
  linkedInUrl: '',
  notes: '',
  usAuth: '',
  usAuthExplain: '',
  discloseGender: 'prefer_not_to_say',
  gender: '',
  discloseRace: 'prefer_not_to_say',
  race: [],
  raceCustom: '',
  discloseLgbtq: 'prefer_not_to_say',
  lgbtq: 'prefer_not_to_say',
  discloseMilitary: 'prefer_not_to_say',
  military: 'prefer_not_to_say',
  militaryNotes: '',
  athlete: 'No',
  sports: '',
  refId: '',
  studentId: null,
}

const StudentPage = (props) => {
  const [state, setState] = useState({
    data: defaultStateData,
    signUpFilled: false,
    canGoBack: true,
    canContinue: false,
    loading: true,
    showFooter: true,
    onContinue: () => {
      props.history.push('/student/signup');
    },
  });

  const continueText = useMemo(() => {
    switch (props.history.location.pathname) {
      case '/student/interests':
        return 'Complete Registration';
      case '/student/create-profile':
        return 'Set up Profile';
      default:
        return 'Continue';
    }
  }, [props.history.location.pathname])

  const updateState = useCallback((newState, save = true) => {
    setState(prev => {
      if (save && newState.data) {
        localStorage.setItem('student-signup', JSON.stringify({
          ...prev.data,
          ...newState.data
        }));
      }

      return {
        ...prev,
        ...newState,
        data: {
          ...prev.data,
          ...newState.data,
        }
      };
    });
  }, []);

  const clearSavedState = useCallback(() => {
    updateState(defaultStateData, false);
    localStorage.removeItem('student-signup');
  }, []);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('student-signup'));
    let signUpFilled = true;

    if (data) {
      for (const dataKey in defaultStateData) {
        switch (dataKey) {
          case 'school':
          case 'schoolCustom':
            signUpFilled = signUpFilled && (!!data.school || !!data.schoolCustom);
            break;

          case 'firm':
          case 'firmCustom':
            signUpFilled = signUpFilled && (!!data.firm || !!data.firmCustom);
            break;

          case 'workLocation':
            signUpFilled = signUpFilled && data.workLocation.length > 0;
            break;

          case 'careerInterests':
          case 'recruitingResources':
          case 'linkedInUrl':
          case 'graduationYearCustom':
          case 'careerInterestsCustom':
          case 'recruitingResourcesCustom':
          case 'firmStartYearCustom':
          case 'notes':
          case 'usAuth':
          case 'usAuthExplain':
          case 'race':
          case 'discloseRace':
          case 'raceCustom':
          case 'discloseGender':
          case 'gender':
          case 'discloseLgbtq':
          case 'lgbtq':
          case 'discloseMilitary':
          case 'military':
          case 'militaryNotes':
          case 'athlete':
          case 'sports':
          case 'refId':
          case 'studentId':
            break;

          default:
            signUpFilled = signUpFilled && !!data[dataKey];
            break;
        }
      }
    }

    if (data) {
      setState(prev => ({
        ...prev,
        data: {
          ...prev.data,
          ...data,
        },
        signUpFilled,
        loading: false,
      }));
    } else {
      setState(prev => ({
        ...prev,
        signUpFilled,
        loading: false,
      }));
    }
  }, []);

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const refId = currentUrl.searchParams.get('refId');

    if (refId) {
      updateState({data: {refId}});
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <div className={classNames('student-signup', `student-signup--${props.match.params.page}`)}>
      {props.match.params.page === 'school' && (
        <p className={'student-signup__disclaimer'}>Note: GoBuyside has no affiliation with these colleges and universities; names and logos are displayed for informational purposes and clarity.</p>
      )}
      <Section>
        <div className={'student-signup__content'}>
          <Switch>
            <Route path={'/student/school'}>
              <SchoolPage {...props} state={state} updateState={updateState} clearSavedState={clearSavedState}/>
            </Route>
            <Route path={'/student/hello'}>
              <HelloPage {...props} state={state} updateState={updateState} clearSavedState={clearSavedState}/>
            </Route>
            <Route path={'/student/signup'}>
              <SignUpPage {...props} state={state} updateState={updateState} clearSavedState={clearSavedState}/>
            </Route>
            <Route path={'/student/questions'}>
              <QuestionsPage {...props} state={state} updateState={updateState}/>
            </Route>
            <Route path={'/student/interests'}>
              <InterestsPage {...props} state={state} updateState={updateState}/>
            </Route>
            {/*<Route path={'/student/complete'}>*/}
            {/*  <CompletePage {...props} state={state} updateState={updateState} clearSavedState={clearSavedState}/>*/}
            {/*</Route>*/}
            {/*<Route path={'/student/create-profile'}>*/}
            {/*  <CreateProfilePage {...props} state={state} updateState={updateState}/>*/}
            {/*</Route>*/}
            <Route path={'/student/success'}>
              <SuccessPage {...props} state={state} updateState={updateState} clearSavedState={clearSavedState}/>
            </Route>
          </Switch>
        </div>
        {state.showFooter && (
          <div className={'student-signup__footer'}>
            {props.history.location.pathname !== '/student/school' && state.canGoBack && (
              <Button
                className={'button--back'}
                size={'xl'}
                icon={ArrowLeftIcon}
                iconProps={{size: 21}}
                secondary
                onClick={() => {
                  props.history.goBack();
                }}
              >
                Back
              </Button>
            )}
            <Button
              className={'button--forward'}
              size={'xl'}
              icon={ArrowRightIcon}
              iconProps={{size: 21}}
              iconPosition={'right'}
              disabled={!state.canContinue}
              secondary
              onClick={state.onContinue}
            >
              {continueText}
            </Button>
          </div>
        )}
      </Section>
      {!!state.data.school && (state.data.school.shortName || state.data.school.name) && props.match.params.page === 'hello' &&  (
        <p className={'student-signup__disclaimer'}>This welcome page is provided for informational purposes as many of our candidate members are school
          alumni. GoBuyside claims no affiliation with {state.data.school.shortName || state.data.school.name}.</p>
      )}
    </div>
  );
}

export default StudentPage;
